<div mat-dialog-title class="dialogHeader">
  <div class="titleWrapper">
    <h3>{{ 'users.policyGroups.chooseResourceTypeLocation' | t }}</h3>
    <mat-form-field appearance="standard">
      <mat-label class="mat-label">{{ 'common.selectPageSize' | t }}</mat-label>
      <mat-select [(value)]="selected">
        <mat-option class="mat-option" value="10" (click)="loadTenLocations()"> 10 </mat-option>
        <mat-option class="mat-option" value="20" (click)="loadTwentyLocations()"> 20</mat-option>
        <mat-option class="mat-option" value="all" (click)="loadAllLocations()"> {{ 'common.all' | t }} </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="searchWrapper">
    <sn-searchbar
      (valueChange)="onSearchValueChange($event)"
      (search)="onSearchValueChange($event)"
      [placeholder]="'common.searchByName' | t"
      [clearOnNavEnd]="false"
    ></sn-searchbar>
  </div>
</div>

<mat-dialog-content>
  <sn-data-list #list [fetchFn]="loadData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyTmpl"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="call()">{{ 'users.policyGroups.addLocations' | t }}</button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let location">
        {{ location.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="location">
      <mat-header-cell *matHeaderCellDef>{{ 'common.location' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let location">
        {{ location ? location.name : ('common.notSpecified' | t) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="floor">
      <mat-header-cell *matHeaderCellDef>{{ 'common.floor' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let location">
        {{ location.floor ? location.floor.name : ('common.notSpecified' | t) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
      <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-object-owner [object]="item"></sn-object-owner>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="selection.toggle(location)" *matRowDef="let location; columns: columns">
    </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
